import { Fade } from "@material-ui/core"
import React from "react";

const TRANSITION_TIMEOUT: number = 1000

const TransitionFade: React.FC<{ show?: boolean }> = ({ show = true, children }) => {

    // Es wird zum Anfag der Seite navigiert, wenn der Inhalt eingebelendet wird.
    const scrollToTop = () => {
        window.scrollTo(0, 0);
    }

    return (
        <Fade in={show} timeout={TRANSITION_TIMEOUT} onEnter={scrollToTop} unmountOnExit>
            <div>
                {children}
            </div>
        </Fade>
    );
}

export default TransitionFade;